import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AppRoutingModule } from './app.routing';
// import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
// import { PERFECT_SCROLLBAR_CONFIG } from 'ngx-perfect-scrollbar';
// import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
// const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
//   suppressScrollX: true
// };
import { NgScrollbarModule } from 'ngx-scrollbar';

import { HttpClient, HttpClientModule } from '@angular/common/http';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
export function HttpLoaderFactory(httpClient: HttpClient) {
  return new TranslateHttpLoader(httpClient, './assets/i18n/', '.json');
}
import { ToastNoAnimationModule, ToastrModule, ToastrService } from 'ngx-toastr';
import { AppSettings } from './app.settings';
import { AppComponent } from './app.component';
import { PagesComponent } from './pages/pages.component';
import { HeaderComponent } from './theme/components/header/header.component';
import { FooterComponent } from './theme/components/footer/footer.component';
import { SidebarComponent } from './theme/components/sidebar/sidebar.component';
import { VerticalMenuComponent } from './theme/components/menu/vertical-menu/vertical-menu.component';
import { HorizontalMenuComponent } from './theme/components/menu/horizontal-menu/horizontal-menu.component';
import { BreadcrumbComponent } from './theme/components/breadcrumb/breadcrumb.component';
import { BackTopComponent } from './theme/components/back-top/back-top.component';
import { UserMenuComponent } from './theme/components/user-menu/user-menu.component';
import { BlankComponent } from './pages/blank/blank.component';
import { SearchComponent } from './pages/search/search.component';
import { NotFoundComponent } from './pages/errors/not-found/not-found.component';
import { FlagsMenuComponent } from './theme/components/flags-menu/flags-menu.component';
import { NgbModule, NgbActiveModal, NgbModal, NgbTimepickerModule } from '@ng-bootstrap/ng-bootstrap';
import { RoleService } from './shared/services/role.service';
import { AppGlobal } from './shared/app.global';
import { EnvService } from './env.service';
import { EnvServiceProvider } from './env.service.provides';
import { AuthService } from './shared/services/auth.service';
import { ContactService } from './shared/services/contact.service';
import { ExcelService } from './shared/services/excel.service';
import { TokenService } from './shared/services/token-service';
import { UserOrg } from './shared/services/userorg.service';
import { LocationService } from './shared/services/location.service';
import { LoginService } from './shared/services/login.service';
import { MemberService } from './shared/services/member.service';
import { OrgService } from './shared/services/org.service';
import { NotifyService } from './shared/services/notificaton.service';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { environment } from 'src/environments/environment';
import { CommonModule } from '@angular/common';
import { AuthGuard } from './guards/auth.guard';
import { BrowserAnimationsModule} from '@angular/platform-browser/animations';
// import { DetailComponent } from './src/app/pages/team/detail/detail.component';
@NgModule({
  imports: [
    BrowserModule,
    FormsModule,
    CommonModule ,
  
    NgbModule,
    ReactiveFormsModule,
    // PerfectScrollbarModule,
    NgbModule,
    NgScrollbarModule,
    AppRoutingModule,
    HttpClientModule,
    // BrowserAnimationsModule,
    NgbTimepickerModule,
    // NgxDaterangepickerMd.forRoot(),
    ToastNoAnimationModule.forRoot(),
    BrowserAnimationsModule,
    ToastrModule.forRoot({
      timeOut: 10000,
      positionClass: 'toast-bottom-right',
      preventDuplicates: true,
    }),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),

    // AngularFireModule.initializeApp(environment.firebase),
    // AngularFireDatabaseModule,
    // AngularFireAuthModule,
    // AngularFirestoreModule ,
  ],
  declarations: [
    AppComponent,
    PagesComponent,
    HeaderComponent,
    FooterComponent,
    SidebarComponent,
    VerticalMenuComponent,
    HorizontalMenuComponent,
    BreadcrumbComponent,
    BackTopComponent,
    UserMenuComponent,
    BlankComponent,
    SearchComponent,
    NotFoundComponent,
    FlagsMenuComponent,
    // DetailComponent
  ],
  providers: [
    // private loginService: LoginService,
    MemberService,TokenService,OrgService,RoleService,AuthService,UserOrg,LocationService,NgbModal,NotifyService,
    AppSettings,
    AppGlobal,
    AuthService,
    ExcelService,
    UserOrg,
    ToastrService,
    AuthGuard,
    LoginService,
    TokenService,
    // SideChatService,
    // NgxSpinnerService,
    // AngularFirestore,
    ContactService,
    LocationService, EnvService
    // ChatService,
    // { provide: PERFECT_SCROLLBAR_CONFIG, useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
